import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditService } from '../../base';
import { MultiStockReceiptsResult, PurchaseOrderLineProduction } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderLineProductionService extends TmsWebBaseEditService<
  PurchaseOrderLineProduction,
  PurchaseOrderLineProduction
> {
  constructor() {
    super('PurchaseOrderLineProductionItem', $localize`Purchase Order Line Production`);
  }

  // Returns the stock item headers the receipts created, so the screen can print their Product
  // Labels (it used to return nothing at all).
  receiveProductionItems(productionItems: PurchaseOrderLineProduction[]): Observable<MultiStockReceiptsResult> {
    return this.httpService.post<MultiStockReceiptsResult>(`${this.apiUrl}/ReceiveProductionItems`, {
      productionItems,
    });
  }
}
